<template>
  <div :class="[$.plan_item, planData.name, isPopup ? $.popup_item : $.page_item]">
    <div :class="$.title">
      <div
        :class="$.plan_name"
        :style="{textTransform: 'capitalize'}"
      >
        <!-- {{ locales(`${planData.name}_plan_locale`) }} -->
        {{ planData.plan_name }}
      </div>
    </div>
    <div :class="$.description">
      {{ locales(`${planData.plan_title_locale}_plan_info_locale`) }}
    </div>
    <div
      v-if="planData.plan_name !== 'enterprise'"
      :class="[$.price, $.action_box]"
    >
      <div :class="$.panel">
        <div :class="$.usd">
          <span :class="$.usd__currency">$</span><span :class="$.usd__price">{{ `${planData.price}` }}</span><span :class="$.usd__label">USD</span>
        </div>
        <div :class="$.description">
          {{ isAnnual ? `${locales('per_user_billed_annually_locale')}` : `${locales('per_user_locale')} ${locales('per_month_key')}` }}
        </div>
      </div>
      <div
        v-if="!isPopup || isTrial"
        :class="[$.btn, $.upgrade_btn]"
        @click="buyPlanClick(planData)"
      >
        {{ locales('upgrade_now_btn_locale') }}
      </div>
      <div
        v-else-if="isPopup && !planData.isCurrentPaymentPlan"
        :class="[$.btn, $.upgrade_btn]"
        @click="upgradePlanClick(planData)"
      >
        {{ locales('upgrade_now_btn_locale') }}
      </div>
      <div
        v-else-if="isPopup && planData.isCurrentPaymentPlan"
        :class="[$.current_plan_sticker, planData.name]"
      >
        <webix-ui
          :class="$.plan_check_icon"
          :config="icons.check"
        />
        <div :class="$.sticker_text">
          {{ locales('current_plan') }}
        </div>
      </div>
    </div>
    <div
      v-else
      :class="[$.demo, $.action_box]"
    >
      <div :class="$.panel">
        <div :class="$.demo_title">
          {{ locales('pricing_custom_price_title') }}
        </div>
      </div>
      <div
        :class="[$.btn, $.demo_btn]"
        @click="demoClick"
      >
        {{ locales('demo_btn_locale') }}
      </div>
    </div>
    <div
      :class="$.plan_features"
      :style="{height: `${heights.featuresSection}px`}"
    >
      <!-- <div
        ref="featuresDesc"
        :class="$.features_desc"
        v-html="locales(`${planData.plan_title_locale}_features_list_description`)"
      /> -->
      <div
        ref="featuresDesc"
        :class="$.features_desc"
        v-html="getPlanFeaturesListTitle(planData)"
      />
      <ul
        ref="featuresList"
        :class="$.features_list"
      >
        <li :class="$.item">
          {{ locales(`${planData.plan_title_locale}_feature_1`) }}
        </li>
        <li :class="$.item">
          {{ locales(`${planData.plan_title_locale}_feature_2`) }}
        </li>
        <li :class="$.item">
          {{ locales(`${planData.plan_title_locale}_feature_3`) }}
        </li>
        <li :class="$.item">
          {{ locales(`${planData.plan_title_locale}_feature_4`) }}
        </li>
      </ul>
    </div>
    <a
      :class="[$.about_plan_link, $.link]"
      :href="isPopup === true ? locales(`about_plan_href_${planData.plan_title_locale}`) : '#features'"
      :target="isPopup === true ? '_blank' : null"
      @click="linkClick(planData.plan_name)"
    >
      <!-- <template v-if="isPopup === true">
        {{ locales(`about_link_${planData.plan_title_locale}`) }}
      </template> -->
      <template>
        {{ locales(`about_link_compare`) }}
      </template>
      <svg
        width="20"
        height="12"
        viewBox="0 0 20 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.5 1.5L19 6M19 6L14.5 10.5M19 6H1"
          stroke="#1565C0"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </a>
  </div>
</template>

<script>
import svgIconForVue from '../../common/svgIconForVue';
import bublesIcon from '../../../svg/pricing/pricing_bubles_ic.svg';
import arrowLeft from '../../../svg/pricing/ic_arrow_left.svg';
import peopleIcon from '../../../svg/pricing/pricing_people_ic.svg';
import lockIcon from '../../../svg/ic_lock.svg';
import check from '../../../svg/pricing/check_current_plan_price.svg';
import app from '../../../app';
import plansModel from '../../../models/plans';

export default {
  props: {
    planData: { type: Object, required: true, default: () => {} },
    isPopup: { type: Boolean, required: true, default: false },
    heights: { type: Object, required: true, default: () => {} },
    isAnnual: { type: Boolean, required: true, default: false },
  },
  emits: {
    buyPlanClick: Object,
    upgradePlanClick: Object,
  },
  data() {
    return {
      locales: __,
      userCount: 1,
      icons: {
        bublesIcon: svgIconForVue(bublesIcon, 62, 49),
        arrowLeft: svgIconForVue(arrowLeft, 27, 16),
        peopleIcon: svgIconForVue(peopleIcon, 24, 24),
        lockIcon: svgIconForVue(lockIcon, 24, 24),
        check: svgIconForVue(check, 20, 20),
      },
    };
  },
  computed: {
    isTrial() {
      return plansModel.isTrial();
    },
  },
  methods: {
    getPlanFeaturesListTitle(planData) {
      let planName;

      if (planData && 'plan_id' in planData && 'plan_name' in planData) {
        if (planData.plan_id === 14) {
          return __('payment_plan_card_base_features_list_title');
        }

        if (planData.plan_id === 15) {
          planName = 'Core';
        }

        if (planData.plan_id === 16) {
          planName = 'Advanced';
        }

        if (planData.plan_id === 18) {
          planName = 'Business';
        }

        return __('payment_plan_card_features_list_title_by_plan_name', { planName });
      }

      return __(`${planData.plan_title_locale}_features_list_description`);
    },
    buyPlanClick(plan) {
      this.$emit('buyPlanClick', plan);
    },
    async upgradePlanClick(plan) {
      this.$emit('upgradePlanClick', plan);
    },
    demoClick() {
      const planName = this.planData.name;
      app.trigger('messageUsForm:show', 'black-friday-contact-us-form', planName);
      // app.trigger('messageUsForm:show', 'upgrade-via-sale-contact-us-form', planName);
    },
    linkClick(plan) {
      userExtAnalytics.log('pricing_learn_more_clicked', { type: plan });
    },
  },
};
</script>

<style module="$" lang="less">
@import '../../../less/_mixins.less';
@import '../../../less/_fonts.less';
@import '../../../less/_variables.less';

@textColor: #424242;

.btn {
  width: 100%;
  text-align: center;
  .FontLatoBold;
  .fs(14px, 24px);
  background-color: #1565C0;
  border-radius: 4px;
  color: #FFFFFF;
  padding: 4px 0;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    color: #fff;
    background-color: #11519A;
    border-color: #11519A;
  }

  &:active{
    color: #fff;
    background-color: #0D3D73;
    border-color: #0D3D73;
  }
}

.plan_item {
  // width: 252.5px;
  // min-width: 252px;
  border: 1px solid #D0E0F2;
  border-radius: 8px;
  padding: 16px;
  margin-right: 16px;
  min-height: 476px;

  min-width: calc(25% - 16px);
  width: calc(25% - 16px);

  &:last-child {
    margin-right: 0;
  }

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;

    .plan_name {
      .FontLatoBlack;
      .fs(20px, 30px);
      color: @titleHeadColor;
    }

    .people_tooltip {
      display: flex;
      align-items: center;
      height: 30px;
      padding: 0 3px;
      cursor: pointer;

      .count {
        .FontLatoRegular;
        .fs(16px, 30px);
        color: #666666;
        padding-left: 6px;
      }

      &:hover {
        .count {
          color: #1565C0;
        }
      }
    }

    .base_plan_tooltip {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      width: 30px;
      cursor: pointer;

      &:hover {
        background-color: #eee;
        border-radius: 1px;
      }
    }
  }

  .description {
    .FontLatoRegular;
    .fs(12px, 18px);
    color: #666666;
  }

  .title ~ .description {
    margin-bottom: 16px;
    min-height:72px;
  }

  .action_box {
    margin-bottom: 16px;
    .user-count-margin {
      margin-bottom: 0;
    }

    .panel {
      // min-height: 90px;
      height: 50px;
    }
  }

  .price {
    .panel {
      // min-height: 85px;
      margin-bottom: 36px;
      .usd {
        color: #191919;

        &__currency {
          .FontLatoRegular;
          font-size: 20px;
          line-height: 1;
          vertical-align: top
        }

        &__price {
          .FontLatoBlack;
          font-size: 32px;
          line-height: 38px;
          padding: 0 4px 0 2px;
        }

        &__label {
          .FontLatoRegular;
          .fs(20px, 38px);
        }

        &.gray {
          color: #757575;
        }
      }
    }
  }

  .demo {
    .panel {
      // min-height: 85px;
      // margin-bottom: 16px;
      height: 50px;
      margin-bottom: 36px;
      .icon {
        margin-bottom: 10px;
      }

      .demo_title {
        .FontLatoBlack;
        .fs(24px, 28.8px);
        color: #191919;
        margin-bottom: 5px;
      }
    }
  }

  .plan_features {
    .FontLatoRegular;
    .fs(12px, 20px);
    color:#666666;
    margin-bottom: 24px;

    .features_desc {
      margin-bottom: 12px;
      .FontLatoRegular;
      .fs(12px, 21px);
      color:#191919;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .features_list {
      padding-left: 0 !important;

      .item {
        position: relative;
        margin-bottom: 5px;
        display:flex;
        gap:8px;

        &::before {
          content: '';
          position: relative;
          display:block;
          background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzFfMTM0NikiPgo8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIxMCIgZmlsbD0iI0QwRTBGMiIvPgo8cGF0aCBkPSJNNi42NjY5OSAxMC40MTY3TDguOTUxNjEgMTMuMDE1NEM5LjA5NDA0IDEzLjE3NzQgOS4zNTA1MSAxMy4xNjM1IDkuNDc0NjEgMTIuOTg3MUwxMy4zMzM3IDcuNSIgc3Ryb2tlPSIjMTU2NUMwIiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzFfMTM0NiI+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgcng9IjYuNjY2NjciIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==);
          min-width:20px;
          min-height: 20px;
        }
      }
    }
  }

  .locked_view {
    position: absolute;
    bottom: -7px;
    left: 50%;
    transform: translateX(-50%);
    height: 52px;
    width: calc(100% + 16px);
    display: flex;
    align-items: center;
    background-color: #eee;
    border-radius: 2px;
    padding: 0 8px;

    .lock_desc {
      .FontLatoRegular;
      .fs(14px, 20px);
      color: @textColor;
      padding-left: 10px;
    }
  }

  .about_plan_link {
    display: flex;
    align-items: flex-start;
    height: 20px;
    gap:8px;
    &:hover {
      gap:12px;
    }
    &.link {
      .FontLatoBold;
      .fs(12px, 16px);
      color: #1565C0;
      text-decoration: none;
      white-space: nowrap;
      border-bottom: 1px solid transparent;

    }
    & svg {
      min-width: 20px;
      margin-top:2px;
    }
  }

  .current_plan_sticker {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    .FontLatoBold;
    .fs(14px, 24px);
    border-radius: 4px;
    color: #232323;
    padding: 4px 0;
    cursor: pointer;
    background-color: #F1F5FB;

    .sticker_text {
      padding-left: 4px;
      cursor: default;
    }
  }

  &.page_item {
    min-width: calc(25% - 16px);
    width: calc(25% - 16px);
    margin-right: 8px;

    &:last-child {
      margin-right: 0;
    }

    .title {
      .plan-name {
        .FontLatoBlack;
        .fs(20px, 30px);
        color: @titleHeadColor;
      }
    }

    .about_plan_link {
      a {
        color: #424242 !important;
      }
    }
  }
}
</style>
<style lang="less">
.people-tooltip {
  .webix_view {
    cursor: pointer;
  }
}

.current-plan-sticker {
  .webix_view {
    .webix_template {
      svg {
        path {
          fill: #232323
        }
      }
    }
  }
}
</style>
